export const COMMON_SUGGEST_WITH_TREE_DISPLAY_SEPARATOR = ' / ';
